import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20modern%20Tokyo%20cityscape%20with%20sleek%20high-rise%20buildings%20and%20sophisticated%20residential%20areas%20during%20golden%20hour%2C%20professional%20real%20estate%20photography%20with%20clean%20architectural%20lines%20and%20urban%20development%2C%20cinematic%20lighting%20creating%20depth%20and%20luxury%20atmosphere%2C%20shot%20from%20elevated%20perspective%20showing%20metropolitan%20skyline&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="東京の高層ビル群"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/60"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-8 flex flex-col justify-center">
        <div className="w-full">
          <h1 className="text-7xl font-bold text-white leading-tight mb-16" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            <div>理想の住まいを</div>
            <div>確かな実績で届ける</div>
          </h1>

          <div className="flex items-start gap-32 mt-20">
            <div className="text-white">
              <p className="text-2xl font-medium mb-2">創業30年の信頼と実績</p>
              <p className="text-xl text-white/80">10,000件以上の取引実績</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs tracking-wider">SCROLL</span>
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
